// ERRORS
export const EMPTY_ERRORS = "EMPTY_ERRORS";
export const GET_ERRORS = "GET_ERRORS";

// ADMIN
export const ADD_ADMIN = "ADD_ADMIN";
export const BEFORE_ADMIN = "BEFORE_ADMIN";
export const LOGIN_ADMIN = "LOGIN_ADMIN";
export const GET_ADMIN = "GET_ADMIN";
export const GET_ADMINS = "GET_ADMINS";
export const UPDATE_ADMIN = "UPDATE_ADMIN";
export const DELETE_ADMIN = "DELETE_ADMIN";
export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const GET_USER_VERIFY = "GET_USER_VERIFY";
export const BEFORE_USER_VERIFY = "BEFORE_USER_VERIFY";
export const VERIFY_ROLE = "VERIFY_ROLE";

// ROLES
export const ADD_ROLE = "ADD_ROLE";
export const UPDATE_ROLE = "UPDATE_ROLE";
export const DELETE_ROLE = "DELETE_ROLE";
export const GET_ROLE = "GET_ROLE";
export const GET_ROLES = "GET_ROLES";
export const BEFORE_ROLE = "BEFORE_ROLE";
export const BEFORE_PERMISSION = "BEFORE_PERMISSION";
export const GET_PERMISSION = "GET_PERMISSION";
export const SET_LOADER_ROLE = "SET_LOADER_ROLE";
export const REMOVE_LOADER_ROLE = "REMOVE_LOADER_ROLE";

// USERS
export const BEFORE_USER = "BEFORE_USER";
export const GET_USERS = "GET_USERS";
export const GET_USER = "GET_USER";
export const UPSERT_USER = "UPSERT_USER";
export const DELETE_USER = "DELETE_USER";

// Settings
export const GET_SETTINGS = "GET_SETTINGS";
export const EDIT_SETTINGS = "EDIT_SETTINGS";
export const BEFORE_SETTINGS = "BEFORE_SETTINGS";
export const CREATE_SUPPORTER = "CREATE_SUPPORTER";
export const CREATE_DONUT = "CREATE_DONUT";
export const DELETE_SUPPORTER = "DELETE_SUPPORTER";

// About
export const GET_ABOUT = "GET_ABOUT";
export const EDIT_ABOUT = "EDIT_ABOUT";
export const BEFORE_ABOUT = "BEFORE_ABOUT";
export const CREATE_AWARD = "CREATE_AWARD";
export const DELETE_AWARD = "DELETE_AWARD";

// DASHBOARD
export const BEFORE_DASHBOARD = "BEFORE_DASHBOARD";
export const GET_DASHBOARD = "GET_DASHBOARD";

// CATEGORIES
export const CREATE_CATEGORY = "CREATE_CATEGORY";
export const LIST_CATEGORIES = "LIST_CATEGORIES";
export const GET_CATEGORY = "GET_CATEGORY";
export const EDIT_CATEGORY = "EDIT_CATEGORY";
export const SELECT_CATEGORIES = "SELECT_CATEGORIES";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const BEFORE_CATEGORY = "BEFORE_CATEGORY";
export const BEFORE_CATEGORIES = "BEFORE_CATEGORIES";

// TEAM MEMBERS
export const CREATE_TEAM_MEMBER = "CREATE_TEAM_MEMBER";
export const LIST_TEAM_MEMBERS = "LIST_TEAM_MEMBERS";
export const EDIT_TEAM_MEMBER = "EDIT_TEAM_MEMBER";
export const DELETE_TEAM_MEMBER = "DELETE_TEAM_MEMBER";
export const GET_TEAM_MEMBER = "GET_TEAM_MEMBER";
export const BEFORE_TEAM_MEMBER = "BEFORE_TEAM_MEMBER";

//DOUMENTS
export const CREATE_DOCUMENT = "CREATE_DOCUMENT";
export const LIST_DOCUMENTS = "LIST_DOCUMENTS";
export const DELETE_DOCUMENT = "DELETE_DOCUMENT";
export const BEFORE_DOCUMENT = "BEFORE_DOCUMENT";
export const BEFORE_DOCUMENTS = "BEFORE_DOCUMENTS";

//CONTENT
export const CREATE_CONTENT = "CREATE_CONTENT";
export const LIST_CONTENTS = "LIST_CONTENTS";
export const GET_CONTENT = "GET_CONTENT";
export const EDIT_CONTENT = "EDIT_CONTENT";
export const DELETE_CONTENT = "DELETE_CONTENT";
export const BEFORE_CONTENT = "BEFORE_CONTENT";
export const BEFORE_CONTENTS = "BEFORE_CONTENTS";

//GALLERY
export const CREATE_GALLERY = "CREATE_GALLERY";
export const LIST_GALLERY = "LIST_GALLERY";
export const DELETE_GALLERY = "DELETE_GALLERY";
export const BEFORE_GALLERY = "BEFORE_GALLERY";

//EVENT
export const CREATE_EVENT = "CREATE_EVENT";
export const LIST_EVENTS = "LIST_EVENTS";
export const GET_EVENT = "GET_EVENT";
export const EDIT_EVENT = "EDIT_EVENT";
export const DELETE_EVENT = "DELETE_EVENT";
export const BEFORE_EVENT = "BEFORE_EVENT";
export const BEFORE_EVENTS = "BEFORE_EVENTS";

// CATEGORIES
export const CREATE_SLIDER = "CREATE_SLIDER";
export const LIST_SLIDERS = "LIST_SLIDERS";
export const GET_SLIDER = "GET_SLIDER";
export const EDIT_SLIDER = "EDIT_SLIDER";
export const SELECT_SLIDERS = "SELECT_SLIDERS";
export const DELETE_SLIDER = "DELETE_SLIDER";
export const BEFORE_SLIDER = "BEFORE_SLIDER";
export const BEFORE_SLIDERS = "BEFORE_SLIDERS";
